export const LIST_END_REACHED_THRESHOLD = 500
export const LIST_LOAD_LIMIT = 10
